import React from 'react';
import { graphql } from 'gatsby';
import LayoutContainer from '../containers/layout';
import SEO from '../components/seo';
import PostDetails from '../components/PostDetails/postDetails';
import ContainerBG from '../components/ContainerBG/container-bg';
import { ContainerBGStyleListTypes } from '../utils/utils';

export const query = graphql`
  query newsTemplateQuery($id: String!) {
    post: sanityNews(id: { eq: $id }) {
      id
      _rawNewsImage
      _rawBody
      _rawExcerpt
      _rawSlug
      DateOfPublication
      BilateralContainerLayoutStyleListTypes
      showCTA
      headline
      featuredNews
    }
  }
`;

const BlogPostTemplate = (props) => {
  return (
    <LayoutContainer>
      <SEO title="News Post Details" />
      <ContainerBG styles={ContainerBGStyleListTypes.LIGHT}>
        <PostDetails context={props?.pathContext} content={props?.data?.post} />
      </ContainerBG>
    </LayoutContainer>
  );
};

export default BlogPostTemplate;
